<template>
    <xx-search-form
        v-model="query"
        :fields="searchFields"
        @submit="onSearch"
        @reset="onReset"
    >
        <template slot="skuNameOrId">
            <mc-select
                v-model="query.skuNameOrId"
                :source="skuSource"
                filterable
                clearable
                placeholder="请输入商品名或skuId搜索"
            />
        </template>
        <template slot="code">
            <el-input
                v-model="query.code"
                placeholder="请输入询价单号"
                :maxlength="30"
                :clearable="true"
            />
        </template>
    </xx-search-form>
</template>
<script>
import { getDefaultSearchParams, getSearchFormFields } from '../config';

export default {
    name: 'SearchForm',
    props: {},
    data() {
        return {
            query: getDefaultSearchParams(),
            skuSource: {
                data: [], // 初始选项为空
                ajax: {
                    url: '/api/vss/second/shepherd/supplierSku/list',
                    type: 'hPost',
                    // 初始参数为空，会报错，不行
                    params: {
                        skuName: '',
                        skuCode: '',
                        valid: -1,
                        approveState: -1,
                        paging: {
                            offset: 0,
                            limit: 100,
                        },
                    },
                },
                responseProcessor: (res) => (res.list || []).map((item) => ({
                    value: item.skuId,
                    label: `${item.skuName}`,
                })),
                buildParams: (params, extendsParams) => ({
                    ...params,
                    skuName: extendsParams.query || '',
                }),
            },
        };
    },
    computed: {
        searchFields() {
            return getSearchFormFields.call(this);
        },
    },
    methods: {
        reset() {
            this.query = getDefaultSearchParams();
            this.$emit('reset');
        },
        onSearch() {
            this.$emit('search', { ...this.query });
        },
        onReset() {
            this.reset();
        },
        handleRemoteSearch(keyword) {
            if (keyword && keyword.trim()) {
                // 更新搜索参数
                this.skuSource.ajax.params = {
                    skuName: keyword,
                    skuCode: '',
                    valid: -1,
                    approveState: -1,
                    paging: {
                        offset: 0,
                        limit: 20,
                    },
                };
            } else {
                // 清空搜索结果
                this.skuSource.ajax.params = {
                    skuName: '',
                    skuCode: '',
                    valid: -1,
                    approveState: -1,
                    paging: {
                        offset: 0,
                        limit: 20,
                    },
                };
            }
        },
    },
};
</script>
